import { getObservabilityContext } from './context';
import { sanitizeTelemetryFields } from './privacy';
import { OBSERVABILITY_RUNTIME } from './runtime';
import { ObservabilityContext, TelemetryEvent, TelemetryFields, TelemetrySink } from './types';

export const BROWSER_TELEMETRY_EVENT = 'aqt:telemetry';

export const browserEventSink: TelemetrySink = event => {
  if (typeof globalThis.dispatchEvent === 'function' && typeof CustomEvent === 'function') {
    globalThis.dispatchEvent(new CustomEvent<TelemetryEvent>(BROWSER_TELEMETRY_EVENT, { detail: event }));
  }
};

let telemetrySink: TelemetrySink = browserEventSink;

export function setTelemetrySink(sink?: TelemetrySink): void {
  telemetrySink = sink ?? browserEventSink;
}

export function emitTelemetry(
  name: string,
  fields: TelemetryFields = {},
  context: ObservabilityContext = getObservabilityContext()
): TelemetryEvent {
  const event: TelemetryEvent = Object.freeze({
    context,
    fields: sanitizeTelemetryFields(fields),
    name,
    runtime: OBSERVABILITY_RUNTIME,
    timestamp: new Date().toISOString(),
  });
  telemetrySink(event);
  return event;
}
